import { render, staticRenderFns } from "./TevaMenu.vue?vue&type=template&id=496be891&scoped=true&"
import script from "./TevaMenu.vue?vue&type=script&lang=js&"
export * from "./TevaMenu.vue?vue&type=script&lang=js&"
import style0 from "./TevaMenu.vue?vue&type=style&index=0&id=496be891&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496be891",
  null
  
)

export default component.exports